
import React from 'react';
import { motion } from 'framer-motion';
import { PackageOpen, PlayCircle, LogOut } from 'lucide-react';
import { Order } from '../../../types';
import { TapToConfirm } from '../../TapToConfirm';

interface Props {
    ordersToPickup: Order[];
    onConfirmPickup: () => void;
    onLogout: () => void;
}

export const PickupManifest: React.FC<Props> = ({ ordersToPickup, onConfirmPickup, onLogout }) => {
    return (
        <div className="min-h-screen bg-app-bg flex flex-col items-center justify-center p-6 text-center animate-in fade-in duration-500">
            <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/carbon-fibre.png')] opacity-10 pointer-events-none"></div>

            <div className="w-24 h-24 bg-card-bg border-2 border-sal-cyber-teal rounded-[2rem] flex items-center justify-center mb-8 shadow-xl relative">
                <PackageOpen className="w-12 h-12 text-sal-cyber-teal" />
                <div className="absolute -top-2 -right-2 w-8 h-8 bg-sal-cyber-teal rounded-full flex items-center justify-center text-badge-text-inv font-black text-base border-4 border-card-bg">
                    {ordersToPickup.length}
                </div>
            </div>

            <h2 className="text-3xl font-black text-text-primary mb-2 uppercase tracking-tighter">Missão Recebida</h2>
            <p className="text-text-muted text-base mb-6 max-w-xs font-bold uppercase tracking-widest">Aguardando saída do Hub</p>

            <div className="w-full max-w-sm bg-card-bg/60 backdrop-blur-xl rounded-3xl border border-border-dim overflow-hidden mb-8 shadow-2xl">
                <div className="bg-black/5 dark:bg-black/20 p-4 border-b border-border-dim text-xs font-black text-sal-cyber-teal uppercase tracking-[0.2em] text-left">Manifesto de Carga</div>
                <div className="max-h-64 overflow-y-auto p-3 space-y-2 no-scrollbar">
                    {ordersToPickup.map(o => {
                        const titleId = o.displayId ? `#${o.displayId}` : (o.shortCode ? `#${o.shortCode}` : `#${o.id.slice(-4)}`);
                        return (
                            <div key={o.id} className="flex justify-between items-center bg-card-bg p-4 rounded-2xl border border-border-dim shadow-sm">
                                <div className="text-left">
                                    <div className="text-sm font-black text-text-primary uppercase tracking-tight">{titleId} • {o.customerName.split(' ')[0]}</div>
                                    <div className="text-xs text-text-muted font-bold uppercase mt-1">{o.neighborhood}</div>
                                </div>
                                <div className="text-right">
                                    <span className="text-sm font-mono font-black text-status-ready">R$ {o.orderValue?.toFixed(2)}</span>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>

            <div className="w-full max-w-sm">
                <TapToConfirm
                    label="Iniciar rota"
                    title="Iniciar rota?"
                    description={`Confirmar saída do Hub com ${ordersToPickup.length} pedido(s).`}
                    confirmLabel="Sim, iniciar"
                    successLabel="ROTA INICIADA!"
                    onConfirm={onConfirmPickup}
                />
            </div>
        </div>
    );
};
